<template>
  <div class="base-info-div">
    <div>
      <a-form-model ref="form" :model="formData" layout="inline" style="display: flex" :labelCol="labelCol">
        <a-row style="width: 100%">
          <a-col :span="19">
            <!-- 常规属性遍历 -->
            <div v-for="item in fieldData" :key="item.index">
              <a-col :span="item.colspan" v-if="item.show">
                <!-- 编辑页面 -->
                <a-form-model-item
                  v-if="editFlag"
                  :label="item.label"
                  :prop="item.index"
                  :rules="getFieldRules(item)"
                  :wrapperCol="setWrapperCol(item.colspan)"
                  :class="item.required ? 'require-label' : 'normal-label'"
                  style="width: 100%"
                >
                  <!-- 日期选择框 -->
                  <a-date-picker
                    v-if="item.type == 'date'"
                    valueFormat="YYYY-MM-DD"
                    v-model="formData[item.index]"
                    :disabled="!item.edit"
                    placeholder="请选择"
                    style="width: 100%"
                  />
                  <!-- 数字输入框 -->
                  <a-input-number v-if="item.type == 'number'" v-model="formData[item.index]" :disabled="!item.edit" placeholder="请输入" :min="0" :max="100" />
                  <!-- 单选框 -->
                  <j-dict-select-tag v-if="item.type == 'radio'" type="radio" v-model="formData[item.index]" :disabled="!item.edit" :dictCode="item.dictCode" />
                  <!-- 下拉选择 -->
                  <j-dict-select-tag
                    v-if="item.type == 'select'"
                    type="select"
                    v-model="formData[item.index]"
                    :disabled="!item.edit"
                    :dictCode="item.dictCode"
                    placeholder="请选择"
                  />
                  <!-- 下拉多选 -->
                  <j-multi-select-tag
                    v-if="item.type == 'mutiSelect'"
                    type="multi"
                    v-model="formData[item.index]"
                    :disabled="!item.edit"
                    :dictCode="item.dictCode"
                    placeholder="请选择"
                  />
                  <!-- 地址选择 -->
                  <!-- 
                  <area-select
                      v-if="item.index == 'address'"
                      @change="changeCity"
                      :disabled="!item.edit"
                      :provinceValue="formData.province"
                      :cityValue="formData.city"
                      :countyValue="formData.county"
                  />-->
                  <!-- 文本输入框 -->
                  <a-input v-if="item.type == 'text'" v-model.trim="formData[item.index]" :disabled="!item.edit" placeholder="请输入" allowClear />
                  <!-- 多行文本输入框 -->
                  <a-textarea
                    v-if="item.type == 'textarea'"
                    v-model.trim="formData[item.index]"
                    :disabled="!item.edit"
                    placeholder="请输入"
                    rows="4"
                    :maxlength="item.maxChar || 1000"
                    allowClear
                  />
                  <!-- 图片框 -->
                  <JImageUpload
                    v-if="item.type == 'img' || item.type == 'headPic'"
                    name="file"
                    :formData="{ ...item, url: formData[item.index] }"
                    @change="changeCallBack(item, $event)"
                  />
                </a-form-model-item>

                <!-- 只读页面 -->
                <a-form-model-item
                  :label="item.label"
                  :required="item.required"
                  :class="item.required ? 'require-label' : 'normal-label'"
                  style="width: 100%"
                  v-else
                >
                  <div v-if="item.type == 'img' || item.type == 'headPic'">
                    <img v-if="formData[item.index]" :src="formData[item.index]" style="max-width: 300px; height: 146px" />
                  </div>
                  <div v-else>
                    <span v-if="item.dictCode">{{ formData[item.index + '_dictText'] }}</span>
                    <span v-else-if="item.index === 'address'">{{ formData.province }}{{ formData.city }}{{ formData.county }}{{ formData.address }}</span>
                    <span v-else>{{ formData[item.index] }}</span>
                  </div>
                </a-form-model-item>
              </a-col>
            </div>
          </a-col>
          <a-col :span="5">
            <!-- 图片属性遍历 -->
            <div v-for="item in imgData" :key="item.index" style="margin-top: 12px; width: 150px; text-align: center">
              <div v-if="editFlag">
                <JImageUpload name="file" :formData="{ ...item, url: formData[item.index] }" @change="changeCallBack(item, $event)" />
                <label :class="item.required ? 'ant-form-item-required' : ''">{{ item.label }}</label>
              </div>
              <div v-else>
                <div>
                  <div style="border: 1px dashed #d9d9d9">
                    <img v-if="!formData[item.index]" src="../../../../static/images/nan.jpg" alt="avatar" style="width: 150px; height: 146px" />
                    <img v-else :src="formData[item.index]" alt="avatar" style="width: 135px; height: 146px" />
                  </div>
                  <span>{{ item.label }}</span>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import NationSelect from './NationSelect';
import AreaSelect from './AreaSelect';
import JImageUpload from './JImageCutUpload.vue';

export default {
  name: 'StudentBaseInfo',
  components: {
    AreaSelect,
    NationSelect,
    JImageUpload,
  },
  props: {
    fieldData: Array,
    imgData: Array,
    editFlag: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    editFlag(val) {
      this.editFlag = val;
    },
  },
  data() {
    return {
      labelCol: { span: 2 },
      wrapperCol_8: { span: 12 },
      wrapperCol_12: { span: 16 },
      wrapperCol_24: { span: 20 },
      formData: {},
      headers: { 'X-Access-Token': localStorage.getItem('token') },
    };
  },
  created() {},
  methods: {
    // 地址选择
    changeCity(record) {
      this.formData.province = record.province || undefined;
      this.formData.city = record.city || undefined;
      this.formData.county = record.county || undefined;
    },
    // 头像上传成功响应事件
    changeCallBack(item, info) {
      this.formData[item.index] = info.response.result;
    },

    // 设置字段wrapperCol值
    setWrapperCol(val) {
      if (val === 8) {
        return this.wrapperCol_8;
      } else if (val === 24) {
        return this.wrapperCol_24;
      }
      return this.wrapperCol_12;
    },
    // 获取字段校验规则
    getFieldRules(item) {
      const rules = [];
      // 必填校验
      if (item.required) {
        rules.push({
          required: true,
          message: `${item.label}不能为空`,
          trigger: 'blur',
        });
        // 最小字数校验（仅针对 textarea 类型）
        if (item.type === 'textarea' && item.minChar && item.minChar > 0) {
          rules.push({
            validator: (rule, value, callback) => {
              if (value && value.length < item.minChar) {
                callback(new Error(`${item.label}至少需要输入${item.minChar}个字符`));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          });
        }
      }
      return rules;
    },
  },
};
</script>
<style scoped lang="css">
.base-info-div {
  padding: 10px;
}
.base-info-div >>> .ant-form-item {
  /*异常信息下边距*/
  margin-bottom: 0px;
}
.base-info-div >>> .ant-form-item-label {
  width: auto;
  min-width: 40px;
  text-align: left;
}
.base-info-div >>> .ant-form-item-label > label {
  margin-bottom: 0px;
  width: auto;
  /*margin-right: 1px;*/
  white-space: pre-wrap; /* 或者使用 'normal' */
  word-break: break-all;
  line-height: 18px;
}
.base-info-div >>> .require-label {
}
.base-info-div >>> .normal-label {
  padding-left: 12px; /* 调整为与星号宽度匹配 */
  box-sizing: border-box;
}

/*头像上传模块*/
.upload-avatar >>> .ant-upload-select-picture-card {
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/infocollect/components/StudentBaseInfo.vue